import React, { Component } from 'react';
import '../../Tablet/ContactUs/ContactUs.css';
import '../CostEstimateForm/form.css';
import { Link } from 'react-router-dom';


export default class BlogReply extends Component {
    render() {
        return (
                <>
                    <div className="container">
                        <form >
                            <div className="f-row">
                                <div className="f-column-12">
                                    <textarea style={{height:"150px"}} name="comment" placeholder="Comment.." ></textarea>
                                </div>
                            </div>
                            <div className="f-row">
                                <div className="f-column-4">
                                    <input  type="text" name="name" placeholder="Name"/>
                                </div>
                                <div className="f-column-4 space-top">
                                    <input  type="text" name="email" placeholder="Email"/>
                                </div>
                                <div className="f-column-4 padding-top">
                                    <input  type="text" name="phone" placeholder="Phone Number"/>
                                </div>
                            </div>
                            <div className="cpd-x26012817 cpd-component cpd-component-wrapper" onClick={console.log("testing")}>
                                <div className="cpd-master-button-24ulab">
                                    <Link to = "/">
                                        <div className="cpd-button-i2601281751-SgFFGf cpd-valign-text-middle">
                                            SEND MESSAGE
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </>
        )
    }
}
